import Component from './btn.vue';
export default Component;
